module.exports = __webpack_public_path__ + "static/debates-for-schools-2-c48ceed38b7c37faa84d6530fc2722fd.jpg";